import type { SetupResponse } from '@tandemone/types'

import { api } from '@/api/client'

export async function getSetupState(
  signal?: AbortSignal
): Promise<SetupResponse> {
  const { data } = await api.get<SetupResponse>('/v1/setup', { signal })
  return data
}
